import { query, request } from '@/utils/request';
import { stringify } from 'qs';
import { getAppyDetailInterface, getClaimDetailInterface } from 'src/config/sceneEnum';

const urls = {
  list: '/zlb/api/expense/common/operateQuery', // 列表
  institution: '/api/zlbuser/institution/by/dataRule',
  apply: '/zlb/api/expense/apply-form/query',
  claim: '/zlb/api/expense/expense-form/getInfoOnCashier',
  getMobile: '/api/workbench/my/confirm_info/get', // 信息确认
};

// 列表查询
export const requestList = (params) => {
  return request(`${urls.list}?${stringify(params)}`);
};

// 单位列表查询
export const requestInstitution = (params) => {
  return request(urls.institution, {
    params,
  });
};

// 申请单详情
export const reqApplyFormDetail = (params) => {
  return request(getAppyDetailInterface(), {
    params,
  });
};

// 报销单详情
export const reqClaimFormDetail = (params) => {
  return request(getClaimDetailInterface(), {
    params,
  });
};

// 获取工作流
export const getWorkFlowInfo = (params) => {
  return request('/zlb/api/expense/workflow/query', {
    params,
  });
};


export async function reqMobile (params) {
  return request(urls.getMobile, { params });
}

// 删除
export async function testFormDelete (data) {
  return query('/zlb/api/expense/common/test-form/delete', {
    data,
    method: 'post',
  });
}

export async function queryOperateRecord (params) {
  return query('/zlb/api/expense/common/operate-record', {
    params,
  });
}
// 重置
export async function queryResetProcess (data) {
  return request('/zlb/api/expense/workflow/resume', {
    data,
    method: 'post',
  });
}
// 财务重置
export async function queryFinanceResetProcess (data) {
  return request('/zlb/api/expense/workflow/cashier/resume', {
    data,
    method: 'post',
  });
}


